import { ProblemCategoryDTO } from './../masterdata/models/problemCategory';
import { Component, OnInit, Input } from '@angular/core';
import { LabMDM } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ErrorHandler } from '../utils/error-handler';
import { SenderDTO } from '../masterdata/models/sender-dto';
import { SelectableLab } from '../carrier/selectable-lab';
import { SelectItem } from 'primeng/api';
import { MachineManufacturerOptionOther, MachineManufacturerOptionsExtractor } from '../crud-table/machine-options';
import { Product } from '../masterdata/models/product';

@Component({
  selector: 'app-senders-template',
  templateUrl: './senders-template.component.html',
  styleUrls: ['./senders-template.component.css']
})
export class SendersTemplateComponent implements OnInit {

  @Input() masterLists: SenderDTO[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() checkSelectedLab: SelectableLab;
  @Input() productOptions: Product[];

  labOption: LabMDM[]=[];
  isNewMasterList: boolean;
  popupTitle: string;
  masterList: SenderDTO;
  displayMasterListDialog: boolean = false;
  selectedLabName: string;
  selectedLab: LabMDM;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedMasterList: SenderDTO;
  entityOptions: any[];
  senders: any[];
  isActive: string = "active";
  isLab: string = "lab";
  isSenderName: string = "senderName";
  isSenderShortName: string = "senderShortName";
  isBarcodeFormat: string = "barcodeFormat";
  isCheckForIdentity:string = "checkForIdentity";
  isMergeGroup:string = "mergeGroup";
  isBarcodeValidationRequired: string = 'barcodeValidationRequired';
  isDataFormat: string = 'dataFormat';
  isContactID:string = 'contactID';
  isSenderGroupName:string = 'senderGroupName';
  isCategoryType: string ="categoryType"
  isFormat: string = 'format';
  isDefaultPriority: string = 'defaultPriority';
  isAllowedPCRKits: string = 'allowedPCRKits';
  isAllowedExtractorKits: string = 'allowedExtractionKits';
  checkForIdentity: any[] = [];
  dataFormatOptions: any[] = [];
  problemOptions: ProblemCategoryDTO[] = [];
  selectedCategory: ProblemCategoryDTO[] = [];

  deafultPriorityList: SelectItem[] = [];
  allowedPCRKitsList: SelectItem[] = [];
  allowedExtractorKitsList: SelectItem[] = [];
  allowedExtractorManufacturerList: SelectItem[] = [];

  selectedLabId: string;
  mapOfKits: any;
  swabTypeList: SelectItem[] = [];
  cyclerMachineType: string = "Cycler";
  extarctorMachineType: string = "Extractor";
  loadedCyclers: boolean = true;
  loadedExtractors: boolean = true;
  selectedProdType: Product;
  selectedProdTypeName: string;
  isDefaultSender : string = "defaultSender";
  isProductType : string = "products";
  masterLists1 : any;
  selectedProduct : Product;
  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) { }

  ngOnInit() {
    this.popupTitle = this.title.slice(0, -1);
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.entityOptions = [
      { field: 'Tube', label: 'Tube' },
      { field: 'Plate', label: 'Plate' },
      { field: 'Other', label: 'Other' }
    ];
    this.checkForIdentity = [
      { value: 'TRF = Sample', label: 'TRF=Sample' },
      { value: 'TRF = External', label: 'TRF=External' },
      { value: 'None', label: 'None' }
    ];
    this.swabTypeList = [
      { value: 'Dry', label: 'Dry' },
      { value: 'Wet', label: 'Wet' },
      { value: 'Saliva', label: 'Saliva' }
    ];
    this.dataFormatOptions = [
      { value: 'CSV-UK', label: 'CSV-UK' },
      { value: 'CSV', label: 'CSV' },
      { value: 'Excel', label: 'Excel' },
      { value: 'Excel With MultiChannels', label: 'Excel With MultiChannels' },
      { value: 'Excel(retest)', label: 'Excel (retest)' },
      { value: 'HL7', label: 'HL7' }
    ];

    this.deafultPriorityList = [
      { value: 'Standard', label: 'Standard' },
      { value: 'Rush', label: 'Rush' },
      { value: 'SuperRush', label: 'Super Rush' }
    ];
    this.showDropDownForProduct();
  }
  isDataLoaded(machineType,value:boolean){
    if(machineType == this.cyclerMachineType)
      this.loadedCyclers = value;
    else
      this.loadedExtractors = value;
    
  }
  getManufacurersForMachineTypes(machineType){
    let manufacturerList: SelectItem[] = [];
    this.isDataLoaded(machineType,false);
    this._masterDataService.getManufacturesFromMachineTypeAndLabId(machineType,this.selectedLabId).subscribe((response) => {
      if(response && response.data){
          response.data.forEach(element => {
            manufacturerList.push({label: element.manufacturerName, value: element.manufacturerName});
          });
       }
       this.isDataLoaded(machineType,true);
    }, (error: any) => {
      this.isDataLoaded(machineType,true);
      let message = this.errorHandler.handleError(error);
      this._messageService.addErrorMessage(message);
    }); 
   return manufacturerList;
  }
  getKitsForIntialization() {
    this._masterDataService.getSenderSpecificKits(this.selectedLabId, true).subscribe(
      result => {
        this.mapOfKits = new Map(Object.entries(result.data));
        this.allowedPCRKitsList = this.convertArrayOfStringToObjectArray(this.mapOfKits, 'pcr');
        this.allowedExtractorKitsList = this.convertArrayOfStringToObjectArray(this.mapOfKits, 'extraction');
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  convertArrayOfStringToObjectArray(objectToArray: Map<string, Object>, kitType: string) {
    let newArray: any[] = [];
    Object.entries(objectToArray.get(kitType)).forEach(([key, value]) => {
      newArray.push({ label: value, value: value });

    });
    return newArray;
  }

  //Display master Dialog upon clicked on a row
  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.allowedExtractorManufacturerList = this.getManufacurersForMachineTypes(this.extarctorMachineType);
    this.getActiveOptionsForDropdowns();
    let activeProducts = this.productOptions;
    this.productOptions =[];
    for(let value of activeProducts){
      if(value.active){
        this.productOptions.push(value);
      }
  }
    for(let value of this.productOptions){
        if(value.name == this.masterList.products){
          this.selectedProdType  = value;
        }
    }
    this.displayMasterListDialog = true;
  }

  //Retrieve the Active lab for dropdown
  getActiveOptionsForDropdowns() {
    this.labOption=[];
    this.populateProblemsList();
    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }

        let checkSelectedLabName = this.checkSelectedLab.lab.name;
        this.labOptions = results.data;
        this.labOptions.forEach(lab => {
          if(lab.name == checkSelectedLabName) {
            this.labOption.push(lab);
          }
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        });
        this.labOptions = this.labOption;
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );
    this.getKitsForIntialization();

 }
 showDropDownForProduct(){
  this.productOptions=[];
  this._masterDataService.getProducts(true, this.checkSelectedLab.lab._id).subscribe(
    results => {
      if (!results) {
        return;
      }
      this.productOptions = results.data;
      this.productOptions.forEach(products => {
        if (this.masterLists1 && this.masterLists1.products && products._id == this.masterLists1.products.name) {
          this.selectedProdTypeName = this.masterLists1.products.name;
          this.selectedProdType = products;
        }
      })
      if (!this.masterLists1 || !this.masterLists1.products || this.selectedProdTypeName != this.masterLists1.products.name)
        this.selectedProdType = null;
    },
    error => {
      let message = this.errorHandler.handleError(error);
      this._messageService.addErrorMessage(message);
    }
  );

 }
  //Display Add Dialog upon clicking Add button
  showDialogToAddMasterList() {
    this.isNewMasterList = true;
    this.masterList = new SenderDTO;
    this.masterList.defaultPriority = 'Standard';
    this.masterList.allowedPCRKits = [];
    this.masterList.allowedExtractionKits = [];
    this.displayMasterListDialog = true;
    this.allowedExtractorManufacturerList = this.getManufacurersForMachineTypes(this.extarctorMachineType);
    this.getActiveOptionsForDropdowns();
    this.showDropDownForProduct();
    this.selectedLab = null;
    this.selectedCategory = null;
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  //Insert or update Template
  saveMasterList() {
    let masterLists = [...this.masterLists];
    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    }
    else {
      this.updateMasterData(masterLists);
    }
  }

  //Inserts a new Template in DB
  saveMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.products = this.selectedProdType.name;
    this.masterList.categoryType = [];
    if (this.selectedCategory && this.selectedCategory.length > 0) {
      this.selectedCategory.forEach(ele => {
        this.masterList.categoryType.push(ele.categoryName);
      });
    }
    this._masterDataService.addSender(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists = [...this.masterLists];
        masterLists.push(results.data);
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  //Updates a Template in DB
  updateMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.categoryType = [];
    this.masterList.products = this.selectedProdType.name;
    if (this.selectedCategory && this.selectedCategory.length > 0) {
      this.selectedCategory.forEach(ele => {
        this.masterList.categoryType.push(ele.categoryName);
      });
    }
    this._masterDataService.updateSender(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  //Check if the Template Name or Lab is Entered or not, if not disable Save button
  isSaveDisabled() {
    if (this.masterList == undefined || this.masterList == null)
      return true;
    else if (!(this.masterList.senderShortName || '').trim().length) {
      return true;
    }
    return false;
  }
  populateProblemsList() {
    this.problemOptions = [];
    this._masterDataService.getActiveProblemCategoriesList(this.checkSelectedLab.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.problemOptions = results.data;
        this.selectedCategory = [];
        this.problemOptions.forEach(ele => {
          if (this.masterList && this.masterList.categoryType && this.masterList.categoryType.includes(ele.categoryName) ) {
            this.selectedCategory.push(ele);
          }
          if (!this.masterList || !this.masterList.categoryType || !this.selectedCategory) {
            this.selectedCategory = null;
          }
        });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  getAllowedExtractorManufacturerList() {
    return MachineManufacturerOptionsExtractor.concat(MachineManufacturerOptionOther);
  }

}
